<template>
  <div>
    <el-dialog
      title="我的图库"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      custom-class="zm-photo-gallery-dialog"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div class="gallery-wrapper">
        <div class="gallery-category">
          <div class="upload-btn" @click="uploadImage">
            <i class="el-icon-upload el-icon--left"></i>上传图片
          </div>
          <input
            ref="uploadInput"
            style="display: none"
            type="file"
            accept="image/*"
            @change="uploadInputChange"
          />
          <div class="category-tree"></div>
        </div>
        <div class="gallery-main">
          <div class="category-control-wrapper"></div>
          <div class="image-wrapper">
            <div class="image-list-main">
              <el-scrollbar
                wrapStyle="height:500px;overflow-x:hidden;"
                v-loading="imageListLoading"
              >
                <div class="image-list">
                  <div class="image-item image-upload-loading" v-if="imageUploadLoading">
                    <i class="el-icon-loading"></i><span class="image-upload-text">上传中...</span>
                  </div>
                  <div
                    class="image-item"
                    :class="{ active: checkboxStatus(item.id) }"
                    v-for="item in imagesList"
                    :key="item.id"
                    @click="viewImageDetail(item)"
                  >
                    <el-checkbox
                      class="image-checkbox"
                      :value="checkboxStatus(item.id)"
                    ></el-checkbox>
                    <div class="checkbox-click-wrapper" @click="imageCheckboxChange(item)"></div>
                    <div class="image-item-main">
                      <img class="image" :src="item.domain + '/' + item.path" />
                      <div class="image-name">{{ item.name }}</div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
              <div class="image-operation-panel">
                <div class="operation-left">
                  <div class="select-images-num">已选中{{ selectImages.length }}张</div>
                  <el-button
                    type="danger"
                    size="mini"
                    :disabled="!selectImages.length"
                    @click="deleteSelectImages"
                    >删除</el-button
                  >
                </div>
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  :total="total"
                  @current-change="paginationChange"
                ></el-pagination>
              </div>
            </div>
            <div class="image-detail-wrapper">
              <div class="image-detail-info">
                <template v-if="imageInfo">
                  <div class="image-box">
                    <img class="image-detail" :src="imageInfo.path" />
                  </div>
                  <div class="info-form">
                    <div class="form-item">
                      <div class="form-label"><span class="must">*</span>图片名</div>
                      <div class="form-content">
                        <el-input size="small" v-model="imageInfo.name"></el-input>
                      </div>
                    </div>
                    <div class="form-item">
                      <div class="form-label">图片大小</div>
                      <div class="form-content">{{ imageInfo.size }}KB</div>
                    </div>
                    <div class="form-item">
                      <div class="form-label">上传时间</div>
                      <div class="form-content">{{ imageInfo.createTime }}</div>
                    </div>
                    <div class="form-item">
                      <div class="form-label">最后修改时间</div>
                      <div class="form-content">{{ imageInfo.updateTime }}</div>
                    </div>
                    <div class="save-wrapper">
                      <el-button size="small" @click="saveImageInfo">保存</el-button>
                    </div>
                  </div>
                </template>
                <div v-else class="no-select-text">没有选中</div>
              </div>
              <div class="gallery-control-wrapper">
                <el-button
                  type="primary"
                  :disabled="!selectImages.length"
                  @click="submitSelectImages"
                  >插入</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from './api'
import { initAxios } from './fetch'
import { formatTime } from './utils'

export default {
  name: 'zm-photo-gallery',
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    // 多选时候的数量 0 不限制 只有在multiple 为true的时候生效
    multipleLimit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      imagesList: [], // 图片的数组
      imageInfo: null, // 查看图片详情数据
      currentPage: 1, // 图片当前页数
      pageSize: 30, // 图片每页的数量
      total: 0, // 总图片数
      selectImages: [], // 选中的图片数组
      imageUploadLoading: false, // 是否有图片正在上传
      imageListLoading: false, // 获取图片列表loading
      dialogVisible: false,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.getImagesList()
      }
    },
  },
  computed: {
    checkboxStatus() {
      return function(id) {
        return this.selectImages.some(item => item.id === id)
      }
    },
  },
  mounted() {
    initAxios()
  },
  methods: {
    // 获取图片列表
    getImagesList() {
      let data = {
        page: this.currentPage,
        category_id: '',
        page_size: this.pageSize,
      }
      this.imageListLoading = true
      api.getPictureList(data).then(res => {
        if (res.status) {
          this.total = res.data.total_count
          this.imagesList = res.data.items.map(item => {
            return {
              id: item.id,
              name: item.name,
              domain: item.save_domain,
              path: item.image_path,
              size: (item.size / 1024).toFixed(2),
              createTime: formatTime(item.created_at),
              updateTime: formatTime(item.updated_at),
            }
          })
        }
        this.imageListLoading = false
        this.imageUploadLoading = false
      })
    },

    // 图片页面切换
    paginationChange(currentPage) {
      this.currentPage = currentPage
      this.getImagesList()
    },

    // 查看图片详情
    viewImageDetail(imageInfo) {
      this.imageInfo = {
        id: imageInfo.id,
        path: imageInfo.domain + '/' + imageInfo.path,
        name: imageInfo.name,
        size: imageInfo.size,
        createTime: imageInfo.createTime,
        updateTime: imageInfo.updateTime,
      }
    },

    // 图片的checkbox切换选中状态
    imageCheckboxChange(imageInfo) {
      let selectImage = {
        id: imageInfo.id,
        domain: imageInfo.domain,
        path: imageInfo.path,
      }
      let selectStatus = this._getCurrnetImageIsSelect(selectImage.id)
      if (this.multiple) {
        // 多选状态
        if (selectStatus) {
          // 选中了则取消选中
          let index = this.selectImages.findIndex(item => item.id === selectImage.id)
          if (index > -1) {
            this.selectImages.splice(index, 1)
          }
        } else {
          if (!this._checkMultipleLimit()) {
            // 如果不能选择
            this.$message.error(`最多可以选择${this.multipleLimit}张图片哦`)
            return
          }
          // 如果是选中状态
          this.selectImages.push(selectImage)
        }
      } else {
        // 单选状态
        if (selectStatus) {
          this.selectImages = []
        } else {
          this.selectImages = [selectImage]
        }
      }
    },

    // 上传图片
    uploadImage() {
      this.$refs.uploadInput.click()
    },

    // 选择上传的图片
    uploadInputChange(e) {
      let files = e.target.files
      if (files.length) {
        let file = files[0]
        let isImageType =
          file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
        let isSize = file.size / 1024 / 1024 < 2
        if (!isImageType) {
          this.$message.error('上传图片只能是 JPG/PNG/GIF 格式!')
          return
        }
        if (!isSize) {
          this.$message.error('上传图片大小不能超过 2MB!')
          return
        }
        let formData = new FormData()
        formData.append('upfile', file)
        formData.append('category_id', 0)
        this.imageUploadLoading = true
        api.uploadImage(formData).then(res => {
          if (res.status) {
            this.getImagesList()
          } else {
            this.imageUploadLoading = false
          }
        })
      }
    },

    // 修改图片名称
    saveImageInfo() {
      let imageInfo = this.imageInfo
      if (!imageInfo.name) {
        this.$message.error('请输入图片名称')
        return
      }
      api.editAlbumById(imageInfo.id, imageInfo.name, '').then(res => {
        if (res.status) {
          this.$message.success(res.message)
          let currentImageIndex = this.imagesList.findIndex(item => item.id === imageInfo.id)
          let currentImage = this.imagesList[currentImageIndex]
          currentImage.name = imageInfo.name
          this.imagesList.splice(currentImageIndex, 1, currentImage)
        }
      })
    },

    // 插入选中的图片
    submitSelectImages() {
      let selectImages = this.selectImages
      if (this.multiple) {
        // 如果多选
        this.$emit('change', selectImages)
      } else {
        // 如果单选
        this.$emit('change', selectImages[0])
      }
    },
    // 删除选中的图片
    deleteSelectImages() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let ids = this.selectImages.map(item => item.id)
          api.delPictureByIds(ids).then(res => {
            if (res.status) {
              this.$message.success(res.message)
              this.getImagesList()
              this.selectImages = []
              if (this.imageInfo && ids.includes(this.imageInfo.id)) {
                this.imageInfo = null
              }
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    closeDialog() {
      this.$emit('update:visible', false)
      this.selectImages = []
    },

    // 获取当前图片是否被选中
    _getCurrnetImageIsSelect(id) {
      return this.selectImages.some(item => item.id === id)
    },

    // 判断是否可以再选择
    _checkMultipleLimit() {
      let multipleLimit = this.multipleLimit
      let multipleStatus = true
      // 如果存在多选限制 并且 等于了当前选中的数量 则返回false
      if (multipleLimit > 0 && this.selectImages.length >= multipleLimit) {
        multipleStatus = false
      }
      return multipleStatus
    },
  },
}
</script>

<style lang="scss">
.zm-photo-gallery-dialog {
  width: 80% !important;
  max-width: 1200px;
  min-width: 800px;
  .el-dialog__header {
    border-bottom: 1px solid #e4e7ed;
    text-align: center;
    .el-dialog__title {
      font-size: 18px;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .image-checkbox {
    display: none;
    position: absolute;
    left: 15px;
    top: 15px;
    .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
    .el-checkbox__inner::after {
      position: absolute;
      top: 3px;
      left: 6px;
      width: 5px;
      height: 8px;
    }
  }
}
</style>
<style lang="scss" scoped>
.gallery-wrapper {
  display: flex;
  .gallery-category {
    width: 210px;
    flex: 0 0 210px;
    border-right: 1px solid #e5e5e5;
    .upload-btn {
      height: 50px;
      background-color: #51c75b;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .category-tree {
      height: 550px;
    }
  }
  .gallery-main {
    flex: 1;
    .category-control-wrapper {
      height: 50px;
      border-bottom: 1px solid #e5e5e5;
      padding: 10px;
      box-sizing: border-box;
    }
    .image-wrapper {
      display: flex;
      .image-list-main {
        flex: 1;
        .el-scrollbar {
          height: 500px;
          .image-list {
            display: flex;
            flex-wrap: wrap;
            .image-item {
              width: 20%;
              height: 150px;
              cursor: pointer;
              padding: 5px;
              position: relative;
              box-sizing: border-box;
              &:hover .image-item-main {
                border-color: #409eff;
              }
              &:hover .image-checkbox {
                display: block;
              }
              &.active .image-item-main {
                border-color: #409eff;
              }
              &.active .image-checkbox {
                display: block;
              }
              .checkbox-click-wrapper {
                position: absolute;
                left: 15px;
                top: 15px;
                width: 24px;
                height: 24px;
                z-index: 2;
              }
              .image-item-main {
                height: 100%;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #ffffff;
                box-sizing: border-box;
                transition: all 0.3s ease 0s;
                .image {
                  max-width: 100%;
                  max-height: 100%;
                }
                .image-name {
                  display: block;
                  width: 100%;
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  height: 25px;
                  line-height: 25px;
                  background-color: rgba(0, 0, 0, 0.25);
                  color: #fff;
                  font-size: 12px;
                  text-align: center;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .image-upload-loading {
              display: flex;
              align-items: center;
              justify-content: center;
              .image-upload-text {
                font-size: 12px;
              }
            }
          }
        }
        .image-operation-panel {
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 1px solid #e5e5e5;
          padding: 0 10px;
          box-sizing: border-box;
          .operation-left {
            display: flex;
            align-items: center;
            .select-images-num {
              font-size: 12px;
              margin-right: 20px;
            }
          }
        }
      }
      .image-detail-wrapper {
        width: 280px;
        flex: 0 0 280px;
        border-left: 1px solid #e5e5e5;
        .image-detail-info {
          height: 500px;
          padding: 10px;
          box-sizing: border-box;
          .image-box {
            text-align: center;
            height: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 40px;
            box-sizing: border-box;
            .image-detail {
              max-width: 100%;
              max-height: 100%;
            }
          }
          .form-item {
            display: flex;
            height: 40px;
            align-items: center;
            .form-label {
              width: 90px;
              flex: 0 0 90px;
              font-size: 12px;
              color: #999999;
              text-align: left;
              .must {
                color: #f56c6c;
                margin-right: 4px;
              }
            }
            .form-content {
              font-size: 12px;
            }
          }
          .save-wrapper {
            margin-top: 10px;
            text-align: center;
          }
          .no-select-text {
            text-align: center;
          }
        }
        .gallery-control-wrapper {
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top: 1px solid #e5e5e5;
        }
      }
    }
  }
}
</style>
